import * as React from "react"
import { EyesCircle } from "./circle"
import { EyesOval } from "./oval"
import { EyesSmile } from "./smile"

const _Eyes = ({ style, isEditor }: { style: string; isEditor?: boolean }) => {
  switch (style) {
    case "circle":
      return <EyesSmile isEditor={isEditor} />
    case "smile":
      return <EyesCircle isEditor={isEditor} />
    case "oval":
    default:
      return <EyesOval isEditor={isEditor} />
  }
}

export const Eyes = React.memo(_Eyes)
